import { AvatarImage } from "@/components/ui/avatar";
import { useAuthenticatedMediaUrl } from "@/hooks/useAuthenticatedMedia";

interface AuthenticatedAvatarImageProps {
  src?: string | null;
  alt?: string;
}

export function AuthenticatedAvatarImage({ src, alt }: AuthenticatedAvatarImageProps) {
  const resolvedSrc = useAuthenticatedMediaUrl(src ?? undefined);
  if (!resolvedSrc) return null;
  return <AvatarImage src={resolvedSrc} alt={alt} />;
}
